import { render, staticRenderFns } from "./PageInstructor.vue?vue&type=template&id=58d957da&scoped=true&"
import script from "./PageInstructor.vue?vue&type=script&lang=js&"
export * from "./PageInstructor.vue?vue&type=script&lang=js&"
import style0 from "./PageInstructor.vue?vue&type=style&index=0&id=58d957da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d957da",
  null
  
)

export default component.exports